import React, { useState } from "react";
import "./styles.css";

import { MouseDraw } from "./MouseDraw";

const ThicknessButton = ({ onClick, value }) => {
  return <button onClick={() => onClick(value)}>{value}</button>;
};

export default function App() {
  const [thickness, setThickness] = useState(1);

  return (
    <div
      className="App"
      style={{ width: "100vw", height: "100vh", overflow: "hidden" }}
    >
      <h1>Click and drag to draw something</h1>
      <div>
        Thickness:{" "}
        {[1, 2, 3, 4].map((i) => (
          <ThicknessButton onClick={setThickness} value={i} key={i} />
        ))}
      </div>
      <svg width="900px" height="900px">
        <MouseDraw x={0} y={0} width={900} height={900} thickness={thickness} />
      </svg>
    </div>
  );
}
